import Tooltip from '../../Tooltip';
export var TooltipCommonProps = {
  appendTo: Tooltip.propTypes['appendTo'],
  disabled: Tooltip.propTypes['disabled'],
  enterDelay: Tooltip.propTypes['enterDelay'],
  exitDelay: Tooltip.propTypes['exitDelay'],
  fixed: Tooltip.propTypes['fixed'],
  flip: Tooltip.propTypes['flip'],
  maxWidth: Tooltip.propTypes['maxWidth'],
  moveArrowTo: Tooltip.propTypes['moveArrowTo'],
  moveBy: Tooltip.propTypes['moveBy'],
  onHide: Tooltip.propTypes['onHide'],
  onShow: Tooltip.propTypes['onShow'],
  placement: Tooltip.propTypes['placement'],
  textAlign: Tooltip.propTypes['textAlign'],
  zIndex: Tooltip.propTypes['zIndex'],
  size: Tooltip.propTypes['size']
};